
import React from 'react';
import { cn } from '@/lib/utils';

interface UsageChartLegendProps {
  payload: any[];
  hiddenSeries: string[];
  onToggleVisibility: (dataKey: string) => void;
  utilityType?: 'energy' | 'gas' | 'water';
}

const UsageChartLegend: React.FC<UsageChartLegendProps> = ({ 
  payload, 
  hiddenSeries, 
  onToggleVisibility,
  utilityType 
}) => {
  if (!payload || !Array.isArray(payload) || payload.length === 0) {
    return null;
  }

  return (
    <div className="flex justify-center mt-4 space-x-4">
      {payload.map((entry, index) => {
        const dataKey = entry.dataKey;
        
        return (
          <div 
            key={`item-${index}`}
            className={cn(
              "flex items-center gap-2 cursor-pointer px-3 py-1.5 rounded-md transition-colors",
              hiddenSeries.includes(dataKey) ? "opacity-50 bg-gray-100 dark:bg-gray-800" : ""
            )}
            onClick={() => onToggleVisibility(dataKey)}
          >
            <span 
              className="inline-block w-3 h-3 rounded-full" 
              style={{ backgroundColor: entry.color }}
            />
            <span className="text-sm font-medium">
              {dataKey === 'electricity' 
                ? 'Energy (kWh)' 
                : dataKey === 'gas' 
                ? 'Gas (m³)' 
                : 'Water (m³)'}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default UsageChartLegend;
